import { render, staticRenderFns } from "./SaveXPathDialog.vue?vue&type=template&id=89513dc0"
import script from "./SaveXPathDialog.vue?vue&type=script&lang=js"
export * from "./SaveXPathDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports